'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// const { JSDOM } = jsdom;
// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved
// import * as templateData from 'redux/modules/templateData';
// import { save } from 'redux/modules/saveUserData';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _draftJs = require('draft-js');

require('draft-js/dist/Draft.css');

var _draftjsConductor = require('draftjs-conductor');

var _semanticUiReact = require('semantic-ui-react');

require('./CommentEditor.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasCommandModifier = _draftJs.KeyBindingUtil.hasCommandModifier;
// import { TextAnalysis, ActionVerbBox, MediaBlock } from 'components';

// const IMAGE_PLACEHOLDER = "https://live.staticflickr.com/8287/29517736620_3184b66ec8.jpg";

var CommentEditor = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    // content_template_data: state.templateData.content_template_data,
    // design_template_name: state.templateData.design_template_name,
    // content_template_name: state.templateData.content_template_name,
    // personal_info: state.templateData.personal_info,
    // info_block: state.templateData.info_block,
    // design_order: state.templateData.design_order,
    // inter_section_margin: state.templateData.inter_section_margin,
    // primary_color: state.templateData.primary_color,
    // secondary_color: state.templateData.secondary_color,
    // header_font: state.templateData.header_font,
    // body_font: state.templateData.body_font,
    // design_template_id: state.templateData.design_template_id,
    // content_template_id: state.templateData.content_template_id,
    // resume_name: state.templateData.resume_name,
    // ReactGA: state.company.ReactGA,
    // content_template_free: state.templateData.content_template_free,
    // subscribed: state.auth.subscribed,
    // all_templates_free: state.company.all_templates_free,
    // show_image_upload: state.company.show_image_upload,
    // text_analysis_data: state.templateData.text_analysis_data,
    // highlighted_action_verb: state.templateData.highlighted_action_verb,
    // analysis_mode_on: state.templateData.analysis_mode_on,
  };
}, {
  // updateInfo: templateData.updateField,
  // saveUserData: save
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(CommentEditor, _Component);

  function CommentEditor(props) {
    (0, _classCallCheck3.default)(this, CommentEditor);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CommentEditor.__proto__ || (0, _getPrototypeOf2.default)(CommentEditor)).call(this, props));

    _this.updateEditorInfo = function (editorState) {

      _this.setState({
        editorState: editorState
      }, function () {
        setTimeout(function () {
          return _this.focus();
        }, 0);
      });

      var element_id = _this.props.data_id;
      var element_parent = _this.props.data_parent;
      var element_type = _this.props.data_type;

      var html = (0, _stringify2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
      _this.props.updateInfo(html, element_id, element_type, element_parent);
    };

    var derivedEditorState = _this.props.value == '' ? _draftJs.EditorState.createEmpty() : _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(JSON.parse(_this.props.value)));

    // console.log(HTMLData);
    // console.log(((JSON.parse(HTMLData))));
    _this.state = {
      editorState: derivedEditorState,
      visible: false,
      showURLInput: false,
      urlValue: '',
      commentValue: '',
      showCommentInput: false,
      text_analysis_data: false,
      highlighted_action_verb: false,
      analysis_mode_on: false
    };

    // this.focus = () => {this.refs.editor.focus()}
    _this.focus = function () {
      _this.commentEditor.focus();
      _this.setState({ visible: true });
    };

    _this.onBlur = function (editorState) {
      _this.setState({ visible: false });
    };

    _this.forceRender = function () {
      var editorState = _this.state.editorState;
      var contentState = editorState.getCurrentContent();

      var newEditorStateInstance = _draftJs.EditorState.createWithContent(contentState, decorator);

      var copyOfEditorState = _draftJs.EditorState.set(newEditorStateInstance, {
        selection: editorState.getSelection(),
        undoStack: editorState.getUndoStack(),
        redoStack: editorState.getRedoStack(),
        lastChangeType: editorState.getLastChangeType()
      });
      _this.setState({ editorState: copyOfEditorState });
    };

    _this.onChange = function (editorState) {
      // console.log(1, editorState.getCurrentContent().getPlainText());
      _this.setState({ editorState: editorState });

      // Worst Hack ever done!!
      // TODO: need to get a json object from server instead of string.
      // or need to process the data coming from server. THIS IS BADD!!!!
      // Doing dummy operation each time to avoid collision with initial array!
      var html = (0, _stringify2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));

      _this.props.onCommentChange(html);
    };

    _this.onTab = function (e) {
      return _this._onTab(e);
    };
    _this.toggleBlockType = function (type) {
      return _this._toggleBlockType(type);
    };
    _this.toggleInlineStyle = function (style) {
      return _this._toggleInlineStyle(style);
    };
    _this.toggleColor = function (toggledColor) {
      return _this._toggleColor(toggledColor);
    };
    _this.myKeyBindingFn = function (e) {
      return _this._myKeyBindingFn(e);
    };
    _this.handleKeyCommand = function (command) {
      return _this._handleKeyCommand(command);
    };

    return _this;
  }

  (0, _createClass3.default)(CommentEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.commentEditor.focus();
      this.setState({ visible: true });
    }
  }, {
    key: '_handleKeyCommand',
    value: function _handleKeyCommand(command) {
      //checking if the copied is fired
      var editorState = this.state.editorState;


      var newState = _draftJs.RichUtils.handleKeyCommand(editorState, command);
      if (newState) {
        this.onChange(newState);
        return true;
      }
      return false;
    }
  }, {
    key: '_onTab',
    value: function _onTab(e) {
      var maxDepth = 4;
      this.onChange(_draftJs.RichUtils.onTab(e, this.state.editorState, maxDepth));
    }
  }, {
    key: '_toggleBlockType',
    value: function _toggleBlockType(blockType) {
      this.onChange(_draftJs.RichUtils.toggleBlockType(this.state.editorState, blockType));
    }
  }, {
    key: '_toggleInlineStyle',
    value: function _toggleInlineStyle(inlineStyle) {
      console.log('toggled');
      this.onChange(_draftJs.RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle));
      // this.props.ReactGA.event({
      //   category: 'Resume - Create Resume ' + this.props.design_template_name + ' - ' + this.props.content_template_name,
      //   action: 'Font - ' + inlineStyle,
      //   label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
      // });
    }
  }, {
    key: '_toggleColor',
    value: function _toggleColor(toggledColor) {
      var editorState = this.state.editorState;

      var selection = editorState.getSelection();
      // Let's just allow one color at a time. Turn off all active colors.
      var nextContentState = (0, _keys2.default)(colorStyleMap).reduce(function (contentState, color) {
        return _draftJs.Modifier.removeInlineStyle(contentState, selection, color);
      }, editorState.getCurrentContent());
      var nextEditorState = _draftJs.EditorState.push(editorState, nextContentState, 'change-inline-style');
      var currentStyle = editorState.getCurrentInlineStyle();
      // Unset style override for current color.
      if (selection.isCollapsed()) {
        nextEditorState = currentStyle.reduce(function (state, color) {
          return _draftJs.RichUtils.toggleInlineStyle(state, color);
        }, nextEditorState);
      }
      // If the color is being toggled on, apply it.
      if (!currentStyle.has(toggledColor)) {
        nextEditorState = _draftJs.RichUtils.toggleInlineStyle(nextEditorState, toggledColor);
      }
      this.onChange(nextEditorState);
    }
  }, {
    key: '_myKeyBindingFn',
    value: function _myKeyBindingFn(e) {
      if (e.keyCode === 13 /* `return` key */ && hasCommandModifier(e)) {
        this.props.confirmComment(e);
        return 'comment-confirmed';
      }

      return (0, _draftJs.getDefaultKeyBinding)(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          editorState = _state.editorState,
          text_analysis_data = _state.text_analysis_data;
      var readOnly = this.props.readOnly;

      // If the user changes block type before entering any text, we can
      // either style the placeholder or hide it. Let's just hide it now.

      var className = 'Editor-editor';
      var styles = require('./CommentEditor.scss');
      var classMultiRoot = "editor-root " + styles.multiline;
      var visible = this.state.visible;
      // var contentState = editorState.getCurrentContent();


      return _react2.default.createElement(
        'div',
        { onClick: this.focus },
        this.state.visible ? _react2.default.createElement(
          _semanticUiReact.Menu,
          {
            style: { position: 'fixed', top: '0px' },
            size: 'mini',
            className: 'multiLineStyleBar',
            fixed: 'top'
          },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', margin: '0 auto' } },
            _react2.default.createElement(InlineStyleControls, {
              editorState: this.state.editorState,
              onToggle: this.toggleInlineStyle
            }),
            _react2.default.createElement(BlockStyleControls, {
              editorState: editorState,
              onToggle: this.toggleBlockType
            }),
            _react2.default.createElement(ColorControls, {
              editorState: editorState,
              onToggle: this.toggleColor
            }),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex' }, className: 'RichEditor-controls' },
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { className: 'editor-styleButton', onMouseDown: this.promptForLink },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkify' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { className: 'editor-styleButton', onMouseDown: this.removeLink },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlinkify' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { className: 'editor-styleButton', onMouseDown: this.promptForComment },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment' })
              ),
              this.props.show_image_upload && _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { className: 'editor-styleButton', onMouseDown: this.onAddImage },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'image' })
              )
            )
          )
        ) : _react2.default.createElement('div', null),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_draftJs.Editor, {
              blockStyleFn: getBlockStyle,
              blockRendererFn: this.blockRenderer,
              customStyleMap: colorStyleMap,
              editorState: editorState,
              keyBindingFn: this.myKeyBindingFn,
              onChange: this.onChange,
              onTab: this.onTab,
              handleKeyCommand: this.handleKeyCommand,
              placeholder: 'Enter text here..',
              spellCheck: true,
              ref: function ref(element) {
                _this2.commentEditor = element;
              },
              onBlur: this.onBlur,
              handlePastedText: this.handlePastedText
            }),
            _react2.default.createElement('div', { className: 'toolbar-draft' })
          )
        )
      );
    }
  }]);
  return CommentEditor;
}(_react.Component)) || _class);
exports.default = CommentEditor;


CommentEditor.defaultProps = {
  editorRootStyle: { minHeight: '0px' }
};

function getBlockStyle(block) {
  switch (block.getType()) {
    case 'blockquote':
      return 'RichEditor-blockquote';
    case 'header-three':
      return 'primary-background';
    default:
      return null;
  }
}

var StyleButton = function (_React$Component) {
  (0, _inherits3.default)(StyleButton, _React$Component);

  function StyleButton() {
    (0, _classCallCheck3.default)(this, StyleButton);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (StyleButton.__proto__ || (0, _getPrototypeOf2.default)(StyleButton)).call(this));

    _this3.onToggle = function (event) {
      event.preventDefault();
      _this3.props.onToggle(_this3.props.style);
    };
    return _this3;
  }

  (0, _createClass3.default)(StyleButton, [{
    key: 'render',
    value: function render() {
      var className = 'editor-styleButton';
      if (this.props.active) {
        className += ' editor-activeButton';
      }

      if (this.props.name === 'header') {
        return _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { className: className,
            onMouseDown: this.onToggle,
            name: this.props.name },
          this.props.label
        );
      }
      if (this.props.name === 'font') {
        return _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { style: { color: this.props.label }, className: className,
            onMouseDown: this.onToggle,
            name: this.props.name },
          _react2.default.createElement(_semanticUiReact.Icon, { name: this.props.name })
        );
      } else {
        return _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { className: className,
            onMouseDown: this.onToggle,
            name: this.props.name },
          _react2.default.createElement(_semanticUiReact.Icon, { name: this.props.name })
        );
      }
    }
  }]);
  return StyleButton;
}(_react2.default.Component);

var INLINE_STYLES = [{ label: 'Bold', style: 'BOLD', name: 'bold' }, { label: 'Italic', style: 'ITALIC', name: 'italic' }, { label: 'Underline', style: 'UNDERLINE', name: 'underline' }];

var InlineStyleControls = function InlineStyleControls(props) {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex' }, className: 'editor-controls' },
    INLINE_STYLES.map(function (type) {
      return _react2.default.createElement(StyleButton, {
        key: type.label,
        active: currentStyle.has(type.style),
        label: type.label,
        onToggle: props.onToggle,
        style: type.style,
        name: type.name
      });
    })
  );
};

var BLOCK_TYPES = [{ label: 'H1', style: 'header-one', name: 'header' }, { label: 'H2', style: 'header-two', name: 'header' }, { label: 'H3', style: 'header-three', name: 'header' },
//{label: 'Blockquote', style: 'blockquote', name:'header'},
{ label: 'UL', style: 'unordered-list-item', name: 'unordered list' }, { label: 'OL', style: 'ordered-list-item', name: 'ordered list' }];
var BlockStyleControls = function BlockStyleControls(props) {
  var editorState = props.editorState;

  var selection = editorState.getSelection();
  var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex' }, className: 'RichEditor-controls' },
    BLOCK_TYPES.map(function (type) {
      return _react2.default.createElement(StyleButton, {
        key: type.label,
        active: type.style === blockType,
        label: type.label,
        onToggle: props.onToggle,
        style: type.style,
        name: type.name
      });
    })
  );
};

var colorStyleMap = {
  red: {
    color: 'rgba(69, 15, 18, 1.0)'
  },
  orange: {
    color: 'rgba(255, 127, 0, 1.0)'
  },
  yellow: {
    color: 'rgba(180, 180, 0, 1.0)'
  },
  green: {
    color: 'rgba(0, 180, 0, 1.0)'
  },
  blue: {
    color: 'rgba(0, 112, 192, 1.0)'
  },
  indigo: {
    color: 'rgba(75, 0, 130, 1.0)'
  },
  violet: {
    color: 'violet'
  },
  centeralign: {
    textAlign: 'center',
    display: 'block'
  },
  leftalign: {
    textAlign: 'left',
    display: 'block'
  },
  rightalign: {
    textAlign: 'right',
    display: 'block'
  },
  justify: {
    textAlign: 'justify',
    display: 'block'
  }
};

var COLORS = [
// {label: 'primary_color', style: 'primary_color', name: 'font'},
//{label: 'Orange', style: 'orange', name: 'font'},
{ label: 'Red', style: 'red', name: 'font' }, { label: 'Blue', style: 'blue', name: 'font' },
//{label: 'Yellow', style: 'yellow', name: 'font'},
//{label: 'Green', style: 'green', name: 'font'},
// {label: 'secondary_color', style: 'secondary_color', name: 'font'},
// {label: 'Indigo', style: 'indigo', name: 'font'},
//{label: 'Violet', style: 'violet', name: 'font'},
{ label: 'Center', style: 'centeralign', name: 'align center' }, { label: 'Left', style: 'leftalign', name: 'align left' }, { label: 'Right', style: 'rightalign', name: 'align right' }, { label: 'Justify', style: 'justify', name: 'align justify' }];
var ColorControls = function ColorControls(props) {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex' } },
    COLORS.map(function (type) {
      return _react2.default.createElement(StyleButton, {
        key: type.label,
        active: currentStyle.has(type.style),
        label: type.label,
        onToggle: props.onToggle,
        style: type.style,
        name: type.name
      });
    })
  );
};

function findLinkEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
  }, callback);
}
var Link = function Link(props) {
  var _props$contentState$g = props.contentState.getEntity(props.entityKey).getData(),
      url = _props$contentState$g.url;

  return _react2.default.createElement(
    'a',
    { rel: 'nofollow noreferrer', target: '_blank', href: url, style: linkStyles.link },
    props.children
  );
};

var linkStyles = {
  root: {
    fontFamily: '\'Georgia\', serif',
    padding: 20,
    width: 600
  },
  buttons: {
    marginBottom: 10
  },
  urlInputContainer: {
    marginBottom: 10
  },
  urlInput: {
    fontFamily: '\'Georgia\', serif',
    marginRight: 10,
    padding: 3
  },
  editor: {
    border: '1px solid #ccc',
    cursor: 'text',
    minHeight: 80,
    padding: 10
  },
  button: {
    marginTop: 10,
    textAlign: 'center'
  },
  link: {
    color: '#3b5998',
    textDecoration: 'underline'
  },
  comment: {
    background: 'lightyellow',
    display: 'inline-block'
  },
  commentInput: {
    width: '100%',
    resize: 'none',
    border: '1px solid grey !important'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CommentEditor/CommentEditor.js
// module id = 1735
// module chunks = 0